import React from 'react';
import styles from './styles.module.scss';

const shimmerDimensions = [ '132px', '125px', '147px', '101px' ];

export function ObjectExplorerBodyShimmer() {
  return (<>
    <div className={styles.objectExplorerSearch}>
      <span className='shimmer shimmer-line' style={{ width: '125px', height: '8px' }} />
    </div>

    <div className={styles.objectExplorerList}>
      {shimmerDimensions.map((dimension, index) => (
        <div key={index} className={styles.objectFieldDetails}>
          <span className='shimmer shimmer-circle mr-1' style={{ width: '12px', height: '12px' }} />
          <span className='shimmer shimmer-line' style={{ width: dimension, height: '8px' }} />
        </div>
      ))}
    </div>
  </>);
}
